import { useEffect, useState } from "react";

const LINES = [
  { text: "$ analyzing business_data.xlsx...", color: "#8fa3bf", delay: 0 },
  { text: "  ✓ Found 2,847 rows across 12 sheets", color: "#4f8cff", delay: 600 },
  { text: "  ✓ Detected 34 duplicate entries", color: "#ff5588", delay: 1200 },
  { text: "  ✓ Standardizing date formats...", color: "#8fa3bf", delay: 1800 },
  { text: "$ building dashboard.py", color: "#8fa3bf", delay: 2600 },
  { text: "  ✓ Revenue trends → chart_01.svg", color: "#4f8cff", delay: 3200 },
  { text: "  ✓ KPI summary → dashboard.xlsx", color: "#4f8cff", delay: 3800 },
  { text: "$ deploying website...", color: "#8fa3bf", delay: 4600 },
  { text: "  ✓ Build complete in 2.1s", color: "#22c55e", delay: 5200 },
  { text: "  ✓ SSL configured · CDN active", color: "#22c55e", delay: 5800 },
  { text: "  ✓ Live at techdataweb.com ✨", color: "#4f8cff", delay: 6400 },
];

export default function TerminalWindow() {
  const [visibleLines, setVisibleLines] = useState<number[]>([]);
  const [cursor, setCursor] = useState(true);
  const [cycle, setCycle] = useState(0);

  useEffect(() => {
    const timers = LINES.map((line, index) =>
      setTimeout(() => setVisibleLines((previous) => [...previous, index]), line.delay),
    );
    return () => timers.forEach(clearTimeout);
  }, [cycle]);

  useEffect(() => {
    const interval = setInterval(() => setCursor((current) => !current), 530);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const restart = setTimeout(() => {
      setVisibleLines([]);
      setCycle((current) => current + 1);
    }, 9500);
    return () => clearTimeout(restart);
  }, [cycle]);

  return (
    <div
      className="rounded-xl overflow-hidden"
      style={{
        background: "#0d1117",
        border: "1px solid rgba(79,140,255,0.2)",
        fontFamily: "'JetBrains Mono', 'Fira Code', 'Courier New', monospace",
        fontSize: "0.78rem",
        boxShadow: "0 0 40px rgba(79,140,255,0.08), 0 20px 60px rgba(0,0,0,0.4)",
      }}
    >
      <div className="flex items-center gap-2 px-4 py-3" style={{ background: "#161b22", borderBottom: "1px solid rgba(255,255,255,0.06)" }}>
        <div className="w-3 h-3 rounded-full" style={{ background: "#ff5f57" }} />
        <div className="w-3 h-3 rounded-full" style={{ background: "#febc2e" }} />
        <div className="w-3 h-3 rounded-full" style={{ background: "#28c840" }} />
        <span className="ml-2 text-xs" style={{ color: "rgba(255,255,255,0.3)", fontFamily: "'Inter', sans-serif" }}>
          tdw-automation — bash
        </span>
      </div>

      <div className="p-5 space-y-1.5" style={{ minHeight: "260px" }}>
        {LINES.map((line, index) => (
          <div
            key={`${cycle}-${index}`}
            className="transition-all duration-300"
            style={{
              color: line.color,
              opacity: visibleLines.includes(index) ? 1 : 0,
              transform: visibleLines.includes(index) ? "translateY(0)" : "translateY(4px)",
              lineHeight: 1.6,
            }}
          >
            {line.text}
          </div>
        ))}
        <div className="flex items-center gap-0" style={{ color: "#4f8cff" }}>
          <span>$ </span>
          <span
            aria-hidden="true"
            style={{
              display: "inline-block",
              width: "8px",
              height: "14px",
              background: cursor ? "#4f8cff" : "transparent",
              marginLeft: "2px",
              verticalAlign: "middle",
              transition: "background 0.1s",
            }}
          />
        </div>
      </div>
    </div>
  );
}
